import {
  Button,
  ButtonProps,
  Center,
  Flex,
  Grid,
  Heading,
  SystemStyleObject,
  Text,
} from '@chakra-ui/react';
import { PropsWithChildren, ReactNode } from 'react';

import { pxToRem } from '../../theme';
import { getTxPath, ViewInBlockExplorerLink } from '../blockchain';
import { CheckmarkIcon, ErrorIconCircle } from '../icons';

export type FormCompletedProps = {
  title: ReactNode;
  onClose?: () => void;
  summary?: ReactNode;
  txHash?: string;
  buttonDisabled?: boolean;
  button?: ReactNode;
  buttonLabel?: ReactNode;
  styles?: {
    container?: SystemStyleObject;
    iconContainer?: SystemStyleObject;
    header?: SystemStyleObject;
    button?: ButtonProps;
  };
};

export function FormCompleted({
  title,
  onClose,
  summary,
  txHash,
  buttonDisabled,
  button,
  buttonLabel,
  styles,
}: FormCompletedProps) {
  return (
    <Grid pt={12} gap={6} {...styles?.container}>
      <Center
        boxSize={pxToRem(56)}
        my={pxToRem(12)}
        mx="auto"
        boxShadow="0 0 0 12px rgba(69, 240, 140, 0.2)"
        bg="primary"
        color="background"
        borderRadius="50%"
        {...styles?.iconContainer}
      >
        <CheckmarkIcon />
      </Center>
      <Heading textAlign="center" size="sm" {...styles?.header}>
        {title}
      </Heading>
      {summary}
      <Flex
        css={{
          mt: 6,
          gap: 4,
          justifyContent: txHash ? 'space-between' : 'center',
          alignItems: 'center',
        }}
      >
        {txHash ? <ViewInBlockExplorerLink path={getTxPath(txHash)} /> : null}
        {buttonDisabled
          ? null
          : button || (
              <Button onClick={onClose} {...styles?.button}>
                {buttonLabel || 'Done'}
              </Button>
            )}
      </Flex>
    </Grid>
  );
}

export function FormCompletedDescription({ children }: PropsWithChildren) {
  return (
    <Text textAlign="center" color="textTertiary" maxW="22em" mx="auto">
      {children}
    </Text>
  );
}

export function VerificationFailed({
  title,
  onClose,
  summary,
}: {
  title: ReactNode;
  onClose?: () => void;
  summary?: ReactNode;
}) {
  return (
    <Grid pt={12} gap={6}>
      <Center>
        <ErrorIconCircle boxSize={14} />
      </Center>
      <Heading textAlign="center" size="sm">
        {title}
      </Heading>
      {summary}
      <Flex
        css={{
          mt: 6,
          gap: 4,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button variant="systemSecondary" onClick={onClose}>
          Done
        </Button>
      </Flex>
    </Grid>
  );
}
